import { Box, Container, Text, VStack, HStack, Link } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { RevealOnScroll } from '../../../atoms/RevealOnScroll';
import PricingPage from '../../PricingPage';

export const PricingPlansPage: React.FC = () => {
  return (
    <>
      <Box bg="white" color="text.darkBlue.900" fontFamily="marketingPage">
        <Container maxW="container.xl" pt={{ base: 8, md: 16 }}>
          <RevealOnScroll>
            {/* Breadcrumb */}
            <HStack
              spacing={4}
              mb={4}
              fontSize="16px"
              color="text.darkBlue.800"
              fontWeight="500">
              <Link
                as={RouterLink}
                to="/resources"
                opacity="0.6"
                _hover={{ opacity: 1, textDecoration: 'underline' }}
                cursor="pointer">
                Resources & Docs
              </Link>
              <Text>/</Text>
              <Text>Pricing Plans</Text>
            </HStack>

            {/* Header */}
            <VStack align="start" spacing={4}>
              <Text fontSize={{ base: '24px', md: '40px' }} fontWeight="700">
                PRICING PLANS
              </Text>
              <Text
                fontSize="15px"
                color="text.darkBlue.800"
                fontFamily="marketingPage"
                fontWeight="normal">
                Choose the plan that matches your goals.
              </Text>
            </VStack>
          </RevealOnScroll>
        </Container>
      </Box>
      <PricingPage />
    </>
  );
};
